import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import QRCode from 'qrcode';
import { EventService } from 'src/app/core/services/event.service';

@Component({
  selector: 'app-web-qr',
  templateUrl: './web-qr.component.html',
  styleUrls: ['./web-qr.component.css']
})
export class WebQrComponent {
  url: string = '';
  qrCode: string = '';
  scanCounts: number = 0;
  hex!: string | null;

  constructor(private http: HttpClient, private eventService: EventService,private router: Router) {}

  ngOnInit() {
    this.hex = localStorage.getItem('eventId');
    const currentUrl =  window.location.origin;
    // console.log('Current URL:', currentUrl); //__CONSOLE_LOG__
    this.url = currentUrl+"/splash/"+this.hex;
  // this.url = "https://events.picaggo.com/splash/f612d976";
    this.generateQRCode();
  }


  async getScanCount() {
    (await (this.eventService.getScanCount(this.hex))).subscribe({
      next: (res: any) => {
        // console.log({ res }); //__CONSOLE_LOG__

        if (res) {
          this.scanCounts = res.result["scan_count"];
        }
      },
      error: (err) => {
        // console.error(err); //__CONSOLE_LOG__
      },
    });
  }


  generateQRCode() {
    const canvas = document.getElementById('qrCodeCanvas') as HTMLCanvasElement;

    if (!this.url) {
      alert('Please enter a valid URL');
      return;
    }

    QRCode.toCanvas(canvas, this.url, { errorCorrectionLevel: 'L' }, (error) => {
      if (error) {
        // console.error('Error generating QR Code:', error); //__CONSOLE_LOG__
        alert('Failed to generate QR Code.');
      }
    });
    this.getScanCount();
  }

  copyUrl() {
    if (!this.url) {
      alert('No URL to copy!');
      return;
    }

    navigator.clipboard.writeText(this.url).then(
      () => alert('URL copied to clipboard!'),
      () => alert('Failed to copy URL.')
    );
  }

  downloadQrCode() {
    const canvas = document.getElementById('qrCodeCanvas') as HTMLCanvasElement;

    if (!canvas) {
      alert('No QR code to download!');
      return;
    }

    const link = document.createElement('a');
    link.href = canvas.toDataURL('image/png');
    link.download = 'qr-code.png';
    link.click();
  }


  // fetchUrlAndQrCode() {
  //   this.http.get<any>('http://localhost:3000/api/url').subscribe({
  //     next: (data) => {
  //       this.url = data.url;
  //       this.qrCode = data.qrCode;
  //       this.scanCounts = data.scanCounts;
  //     },
  //     error: (error) => console.error('Error fetching URL and QR code:', error),
  //   });
  // }
}
